import { render } from "./UpdateNotification.vue?vue&type=template&id=2f6f8ddf&scoped=true"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"

import "./UpdateNotification.vue?vue&type=style&index=0&id=2f6f8ddf&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6f8ddf"]])

export default __exports__